
require('./helpers/directives')
require('./helpers/filters')

_.mixin({
  nestedOmit: function(obj, iteratee, context) {
    var r;
    if (_.isArray(obj)) {
      r = obj;
    } else {
      if(_.isArray(iteratee)){
        _.each(iteratee,function (iter){
            r = _.omit(obj,iter,context);
        });
      }else{
        r = _.omit(obj, iteratee, context);
      }

    }
    //transform the children objects
    _.each(r, function(val, key) {
      if (typeof(val) === "object")
        r[key] = _.nestedOmit(val, iteratee, context);
    });

    return r;
  }
});